import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOrderServiceCreate } from '../../services/order.service';
import CheckoutForm from './CheckoutForm';

import { useGetCartItems } from '../../services/cart-item/cart-item.service';

const Payment = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const [enable, setEnable] = useState(false);
  // const { data, isLoading } = useOrderServiceCreate(enable);
  const { data, isError, error, isSuccess, isLoading, refetch, isFetched } = useGetCartItems();

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || location.state.loadStripeSecret, {
    stripeAccount: location.state.connect_account_id,
  });
  // const options = {
  //   clientSecret: location.state.clientSecret,
  // };
  const options = useMemo(() => {
    return {
      mode: 'payment',
      amount: (data?.data?.price?.amount_with_tax ?? 0.5) * 100,
      currency: 'usd',
      // Fully customizable with appearance API.
      appearance: {
        theme: 'stripe',
        variables: {
          colorPrimary: '#635BFF',
          colorText: '#30313d',
          colorBackground: '#ffffff',
          fontFamily: 'Roboto, sans-serif',
        },
        rules: {
          '.Label': {
            fontWeight: 'bold',
          },
          '.Input': {
            borderRadius: '4px',
            border: '1px solid #ccc',
            padding: '10px',
          },
        },
      },
    } as const satisfies StripeElementsOptions;
  }, [data?.data]);

  return (
    <>
      <div id='checkout'>
        <Elements
          stripe={stripePromise}
          options={{
            ...options,
          }}>
          <CheckoutForm />
        </Elements>
      </div>
    </>
  );
};

export default Payment;
